// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2l-q";
export var animationRelative = "_2l-p";
export var backdropBlur = "_2l-0";
export var detailLabelCell = "_2l-12";
export var detailTable = "_2l-11";
export var detailValueCell = "_2l-13";
export var docIconBox = "_2l-1d";
export var docIconBoxMd = "_2l-1f";
export var docIconBoxSm = "_2l-1e";
export var docTypeRow = "_2l-16";
export var docTypeRowInner = "_2l-17";
export var dropdownMatchDatePicker = "_2l-3";
export var evidenceCardContent = "_2l-1c";
export var fileUploadSpin = "_2l-j";
export var gorgiasOpenButton = "_2l-15 _2l-d";
export var gorgiasTicketCard = "_2l-14";
export var heroModalFooterButton = "_2l-18";
export var hiddenContainer = "_2l-o";
export var iconPrimary = "_2l-1g";
export var iconSecondary = "_2l-1h";
export var iconTertiary = "_2l-1i";
export var integrationCard = "_2l-1";
export var integrationLogoBox = "_2l-2";
export var mainColumnSticky = "_2l-1b";
export var maxWidthContainer = "_2l-19";
export var modalContentBody = "_2l-a";
export var modalHeaderImage = "_2l-5";
export var modalImageLabel = "_2l-7";
export var modalImageOverlay = "_2l-6";
export var modalImageSubtitle = "_2l-9";
export var modalImageTitle = "_2l-8";
export var modalImageWrapper = "_2l-4";
export var modalStickyFooter = "_2l-b";
export var removeButton = "_2l-e";
export var sidebarColumn = "_2l-1a";
export var spinner = "_2l-i";
export var timelineLine = "_2l-y";
export var timelineLineBlack = "_2l-10 _2l-y";
export var timelineLineGray = "_2l-z _2l-y";
export var timelineLineHeight = "_2l-x";
export var tlDotActivate = "_2l-u";
export var tlDotActivateAnim = "_2l-t";
export var tlDotHide = "_2l-s";
export var tlDotHideAnim = "_2l-r";
export var tlLineActivate = "_2l-w";
export var tlLineActivateAnim = "_2l-v";
export var uploadHint = "_2l-n";
export var uploadIconBox = "_2l-k";
export var uploadLabel = "_2l-m";
export var uploadText = "_2l-l";
export var uploadZone = "_2l-f";
export var uploadZoneCursorDefault = "_2l-h";
export var uploadZoneCursorPointer = "_2l-g";
export var uploadedFileRow = "_2l-c";
export var viewButton = "_2l-d";